import { ClipboardCheckIcon, FilesIcon, FolderKanbanIcon, HardHatIcon, ShareIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  purpose?: string;
  progression?: string[];
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Banco de 150 Proyectos de Automatización Industrial Listos para Adaptar',
    description: 'Una colección de 150 proyectos para evitar diseñar propuestas desde cero.',
    items: [
      'PLC y programación Ladder',
      'Sensores y actuadores',
      'Motores y variadores',
      'Electroneumática',
      'Cintas transportadoras',
      'Clasificación automatizada',
      'Bombeo y dosificación',
      'Control de procesos',
      'HMI y supervisión',
      'Redes industriales',
      'Sistemas integrados',
    ],
    progression: ['Elegí', 'Adaptá', 'Implementá en tu aula-taller'],
    value: '$18.000 ARS',
    icon: FolderKanbanIcon,
  },
  {
    number: '02',
    title: 'Kit Completo de Evaluaciones de Automatización Industrial',
    description: 'Un sistema completo para evaluar conocimientos, prácticas y proyectos.',
    items: [
      'Evaluaciones diagnósticas',
      'Evaluaciones teóricas y prácticas',
      'Evaluaciones de PLC y Ladder',
      'Instrumentos para sensores y automatismos',
      'Evaluaciones de aula-taller',
      'Diagnóstico de fallas',
      'Banco de 100 preguntas técnicas',
      '15 rúbricas de evaluación',
      '10 listas de cotejo',
      'Recuperatorios',
      'Instrumentos para proyectos integradores',
    ],
    purpose: 'Evaluar de forma integral sin crear cada instrumento',
    value: '$16.000 ARS',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: 'Banco de Diagramas, Esquemas y Recursos Visuales de Automatización Industrial',
    description: 'Material visual para explicar conceptos técnicos de forma clara y profesional.',
    items: [
      'PLC, ciclo de ejecución y Ladder',
      'Sensores y actuadores',
      'Instrumentación industrial',
      'Electroneumática',
      'Motores y variadores',
      'Redes industriales y protocolos',
      'HMI y SCADA',
      'Procesos automatizados',
      'Diagnóstico de fallas',
      'Seguridad en máquinas',
      'Comparativas y mapas conceptuales',
    ],
    purpose: 'Explicar lo complejo con una imagen',
    value: '$15.000 ARS',
    icon: ShareIcon,
  },
  {
    number: '04',
    title: 'Kit de Documentación Técnica, Formularios y Plantillas de Automatización Industrial',
    description:
      'Un banco de 155 recursos, formularios y plantillas para organizar el trabajo técnico y pedagógico. Además, 20 plantillas esenciales listas para imprimir y utilizar inmediatamente.',
    items: [
      'Desarrollo de proyectos',
      'Prácticas de taller',
      'Relevamientos de datos',
      'Registro de variables',
      'Pruebas de funcionamiento',
      'Diagnóstico y troubleshooting',
      'Mantenimiento preventivo',
      'Puesta en marcha',
      'Seguimiento de actividades',
      'Informes técnicos',
      'Documentación de proyectos',
    ],
    purpose: 'Documentar como en la industria real',
    value: '$14.000 ARS',
    icon: FilesIcon,
  },
  {
    number: '05',
    title: 'Seguridad y Puesta en Marcha Segura en Automatización Industrial',
    description: 'Un recurso específico para integrar seguridad dentro de prácticas y proyectos.',
    items: [
      'Riesgos eléctricos, neumáticos y mecánicos',
      'Arranques inesperados y energías almacenadas',
      'Parada de emergencia',
      'Seguridad en PLC, HMI y sistemas automatizados',
      'Procedimientos de puesta en marcha segura',
      '25 escenarios de seguridad',
      '15 fallas simuladas',
      'Checklists de verificación pre-puesta en marcha',
      'Rúbricas de evaluación de seguridad',
      'Material visual para aula-taller',
      'Protocolos docentes',
    ],
    purpose: 'Formar técnicos seguros y responsables',
    value: '$13.000 ARS',
    icon: HardHatIcon,
    wide: true,
  },
];
